import * as Sentry from '@sentry/browser'
import { getFunnelFromUrl } from '../default/getFunnelFromUrl'
import { getMetricPath } from './captureEvent'

/**
 * Logs a failed front-end form validation to Sentry, one `invalid-<field>` log
 * per field (e.g. `invalid-zipcode`)
 *
 * @param {string[]} fields - ids of the fields that failed validation
 */
export function captureInvalidFields(fields) {
  console.warn('invalid fields:', fields.join())

  if (typeof Sentry.logger?.info !== 'function') return

  const funnel = getFunnelFromUrl()
  const path = getMetricPath()

  fields.forEach((field) => {
    try {
      Sentry.logger.info(`invalid-${field}`, {
        event: `invalid-${field}`,
        field,
        invalid_fields: fields.join(),
        funnel,
        path,
      })
    } catch (error) {
      console.warn('Sentry log failed', error)
    }
  })
}
